// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
};

const requiredConfigKeys = ['apiKey', 'authDomain', 'projectId', 'appId'];
const missingConfigKeys = requiredConfigKeys.filter((key) => !firebaseConfig[key]);

if (missingConfigKeys.length > 0) {
  throw new Error(
    `Firebase is missing required config: ${missingConfigKeys.join(', ')}. ` +
    'Set the matching REACT_APP_* values at build time (local .env or CI secrets).'
  );
}

// Initialize Firebase
export const InitFirebase = () => {
  return initializeApp(firebaseConfig);
};

export const GetAnalytics = (app) => {
  return getAnalytics(app);
};

export const GetFirestore = (app) => {
  return getFirestore(app, 'wb-bas-firestore');
};

export const GetRealtimeDB = (app) => {
  return getDatabase(app);
};

export const FirebaseApp = InitFirebase();
export const Analytics = GetAnalytics(FirebaseApp);
export const FirestoreDB = GetFirestore(FirebaseApp);
export const RealtimeDB = GetRealtimeDB(FirebaseApp);
